export default __webpack_public_path__ + "static/media/Path3541.e6f40cc6.svg";